import { CustomCellRendererProps } from "ag-grid-react";
import { ConsultantFavouriteToggle } from "@consultants/consultant-favourites/consultant-favourite-toggle";
import { ConsultantRowData } from "../../../utils/consultant-row-data";

export function FavouriteStarRenderer(
  props: CustomCellRendererProps<ConsultantRowData>
) {
  const id = props.data?._id;

  if (!id) {
    return null;
  }

  return <ConsultantFavouriteToggle consultantId={id} size="small" />;
}
